import {
  humanizeSolutionType,
  SOLUTION_TYPE,
  SOLUTION_TYPE_FILTER,
  SolutionType,
  SolutionTypeFilter,
} from '../../../../../shared/constants/user-info/solutionType';
import type { Option } from '../../../../../general-types';

export const getFilterOptions = (
  availableSolutions: SolutionType[],
): Option<SolutionTypeFilter>[] | null => {
  const filteredSolutions = availableSolutions.filter(
    (solution) => solution !== SOLUTION_TYPE.CHALLENGE,
  );

  //We don't need to have filter options at all if there is only one solution available (except challenge)
  if (filteredSolutions.length <= 1) {
    return null;
  }

  return [
    { label: 'All', value: SOLUTION_TYPE_FILTER.ALL },
    ...filteredSolutions.map((solution) => ({
      label: humanizeSolutionType[solution],
      value: solution,
    })),
  ];
};
